export default __webpack_public_path__ + "static/media/option-indendoors-trae.22e24684.svg";